import { useMutation, useQueryClient } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { buildErrorMessage } from 'utils'
import { BlogMetadataRecord, BlogMetadataRecordsClient } from 'api/clients/BlogMetadataRecordsClient'
import { useCurrentArticleId } from 'hooks/useCurrentArticleId'

export interface Data extends BlogMetadataRecord {}

export const useUpdateBlogMetadataRecord = () => {
  const articleId = useCurrentArticleId() ?? ''
  const queryClient = useQueryClient()

  return useMutation<Data, unknown, BlogMetadataRecord>(
    ['updateBlogMetadataRecord', articleId],

    async (blogMetadataRecord) => {
      const response = await BlogMetadataRecordsClient.update({ articleId, params: blogMetadataRecord })

      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error(
          buildErrorMessage(response.data.errors) ||
            'An error occurred updating metadata! Our team has been notified and we are looking into it.',
        )
      }

      return response.data
    },
    {
      onSuccess(data) {
        queryClient.setQueryData(['blogMetadataRecord', articleId], data)
      },
    },
  )
}
